import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import type { Organisation } from '@/hooks/use-organisations'
import {
  organisationSwitcherAcronym,
  sortOrganisationsForMenu,
} from '@/utils/organisation-switcher-utils'
import { cn } from '@/lib/utils'
import { Check } from 'lucide-react'

export { sortOrganisationsForMenu }

export function OrgSwitcherAvatar({
  name,
  logoUrl,
  className,
}: {
  name: string
  logoUrl?: string | null
  className?: string
}) {
  const label = organisationSwitcherAcronym(name || '?')
  return (
    <Avatar className={cn('size-8 shrink-0 rounded-md', className)}>
      {logoUrl ? <AvatarImage src={logoUrl} alt="" className="object-cover" /> : null}
      <AvatarFallback className="rounded-md text-xs font-semibold">{label}</AvatarFallback>
    </Avatar>
  )
}

export function OrganisationSwitcherRow({
  org,
  isActive,
  onSwitch,
}: {
  org: Organisation
  isActive: boolean
  onSwitch: () => void
}) {
  return (
    <DropdownMenuItem
      aria-current={isActive ? 'true' : undefined}
      className={cn(
        'min-h-11 cursor-default gap-2 rounded-sm px-2 py-0',
        'hover:bg-muted/50 focus:bg-muted/50 data-[highlighted]:bg-muted/50',
      )}
      onSelect={() => {
        if (!isActive) onSwitch()
      }}
    >
      <OrgSwitcherAvatar name={org.name} logoUrl={org.logo_url} className="size-6" />
      <span
        className={cn(
          'min-w-0 flex-1 truncate text-sm',
          isActive ? 'font-medium text-foreground' : 'font-normal',
        )}
        title={org.name}
      >
        {org.name}
      </span>
      <span className="flex w-4 shrink-0 items-center justify-center" aria-hidden>
        {isActive ? <Check className="size-4 shrink-0 text-primary" /> : null}
      </span>
    </DropdownMenuItem>
  )
}
